import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-radio-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-radio-button.component.html',
  styleUrl: './custom-radio-button.component.css'
})
export class CustomRadioButtonComponent {
  @Input() buttonText: string = '';
  @Input() state: boolean = false;
  @Output() stateChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() defaultBackgroundColor: string = 'bg-primary-100';
  @Input() clickedBackgroundColor: string = 'bg-primary-500';

  @Input() defaultTextColor: string = 'text-neutral-800';
  @Input() clickedTextColor: string = 'text-primary';

  @Input() defaultBorderColor: string = 'border-primary-200';
  @Input() clickedBorderColor: string = 'border-primary-800';

  toggleState(): void {
    this.state = !this.state;
    this.stateChange.emit(this.state);
  }
}
